import { RequestTypeDetailQuery } from 'generated/resources/graphql'

interface GetFeatureFlagsResult {
  isCustomFormsEnabled: boolean
  isWorkflowsEnabled: boolean
}

export function getFeatureFlags(
  requestTypeDetailData?: RequestTypeDetailQuery
): GetFeatureFlagsResult {
  const isCustomFormsEnabled =
    requestTypeDetailData?.features.featuresConnection.nodes.find(
      (feature) => feature.name === 'dev_procurement_custom_forms'
    )?.enabled ?? false

  const isWorkflowsEnabled =
    requestTypeDetailData?.features.featuresConnection.nodes.find(
      (feature) => feature.name === 'dev_procurement_approval_workflows'
    )?.enabled ?? false

  return { isCustomFormsEnabled, isWorkflowsEnabled }
}
